import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import Tasks from './Tasks';
import ScheduleSection from './ScheduleSection/Container';
import MyClients from './MyClients';
import Reminders from './Reminders';

const styles = theme => ({
  root: {
    padding: theme.spacing(3),
    width: '100%',
    backgroundColor: theme.palette.facet.lightGray,
    overflow: 'auto',
  },
  gridContainer: {
    height: '100%',
  },
  card: {
    minHeight: '100%',
  },
  [theme.breakpoints.down('md')]: {
    halfContainer: {
      height: 'fit-content',
    },
  },
  halfContainer: {
    height: `calc(100% - ${theme.spacing(1)}px)`, // <-- adjust for margin between vertical cards
  },
  halfCard: {
    height: '50%',
    overflow: 'scroll',
  },
  gutter: {
    marginBottom: theme.spacing(1),
  },
});

const TodayDashboard = ({ classes, className }) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Today Dashboard',
    isPageView: true,
  });

  return (
    <div
      className={classNames(classes.root, className)}
      test={'advisor-app-dashboard'}
      {...rootNodeProps}
    >
      <Grid container spacing={1} className={classes.gridContainer}>
        <Grid item xs={12} md={4} lg={4} xl={3}>
          <div className={classes.halfContainer}>
            <Paper elevation={3} square className={classNames(classes.halfCard, classes.gutter)}>
              <Tasks />
            </Paper>
            <Paper elevation={3} square className={classNames(classes.halfCard)}>
              <Reminders />
            </Paper>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={8}>
          <ScheduleSection />
        </Grid>
        <Grid item xs={12} md={2} lg={2} xl={1}>
          <Paper elevation={3} square className={classes.card}>
            <MyClients />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

TodayDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

TodayDashboard.defaultProps = {
  className: '',
};

export default withStyles(styles)(TodayDashboard);
